import React from 'react';
import { styled } from '@linaria/react';
import { useSpring, animated } from 'react-spring';

import type { ParticleData } from './LikeButton.types';

function Particle({
  angleInRads,
  distance,
  sprite,
  rotation,
  springConfig,
}: ParticleData) {
  const fromX = Math.cos(angleInRads) * (distance * 0.75);
  const fromY = Math.sin(angleInRads) * (distance * 0.75);
  const toX = Math.cos(angleInRads) * distance;
  const toY = Math.sin(angleInRads) * distance;

  const style = useSpring({
    from: {
      transform: `translate(${fromX}px, ${fromY}px) rotate(0deg)`,
    },
    to: {
      transform: `translate(${toX}px, ${toY}px) rotate(${rotation}deg)`,
    },
    config: springConfig,
  });

  return (
    <Image
      src={sprite.src}
      alt=""
      style={{
        width: sprite.width / 2,
        height: sprite.height / 2,
        ...style,
      }}
    />
  );
}

const Image = styled(animated.img)`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  transform-origin: center center;
  animation: fadeOut 750ms 200ms both;
`;

export default React.memo(Particle);
